module.exports = __webpack_public_path__ + "media/images/eu-logo-rect-5f31056d6c3af5f4558108702252fff0.png";